import { render, staticRenderFns } from "./InSaleItem.vue?vue&type=template&id=51c2c7a6&scoped=true&"
import script from "./InSaleItem.vue?vue&type=script&lang=js&"
export * from "./InSaleItem.vue?vue&type=script&lang=js&"
import style0 from "./InSaleItem.vue?vue&type=style&index=0&id=51c2c7a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2c7a6",
  null
  
)

export default component.exports